import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import { Checkbox } from 'react-icheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const ActionList = ({ t, objectId, objectType, objectName, data, onClick, isReadonly }) => {

	const columns = [
		{
			header: t('Permission_Name'),
			accessor: 'name',
			sortable: true,
			cell: (name) => t(`Permission_Name_${name}`, name)
		},
		{
			header: t('Permission_Description'),
			accessor: 'description',
			sortable: true,
			cell: (description, row) => t(`Permission_Description_${row.name}`, description)
		},
		{
			header: t('Permission_IsExecute'),
			accessor: 'isExecuteGranted',
			sortable: false,
			cell: (isExecuteGranted) => <Checkbox checkboxClass='icheckbox_minimal-grey bg' checked={!!isExecuteGranted}  ></Checkbox>		
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => (<Button onClick={() => onClick(row)} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Button>)
		}
	];



	return (
		<Panel>
			<Panel.Heading>{t('Permission_ActionType') + ' - ' + objectName}</Panel.Heading>
			<Panel.Body>
				<PagedEntitiesList isReadonly={isReadonly} columns={columns} data={data} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(ActionList);
